export default __webpack_public_path__ + "static/media/happy_lady.b32e4a21.png";